<template>
  <div class="shops">
    <DefTitle :result="1">
      <h1>
        {{ messages.title }}
      </h1>
    </DefTitle>
    <div class="shops__header">
      <DefSelectWrapper :value="activeCityName">
        <template #header>
          <span>{{ activeCityName }}</span>
        </template>
        <template #placeholder>
          {{ messages.city }}
        </template>
        <div
          v-for="item in cities.filter((el) => !el.active)"
          :key="item.ID"
          @click="changeCurrentCityId(item.ID)"
        >
          {{ item.UF_NAME }}
        </div>
      </DefSelectWrapper>

      <DefSwitch>
        <button :class="{ active: activeTab === 'list' }" @click="activeTab = 'list'">
          <span>
            {{ messages.list }}
          </span>
        </button>
        <button :class="{ active: activeTab === 'map' }" @click="activeTab = 'map'">
          <span>
            {{ messages.onMap }}
          </span>
        </button>
      </DefSwitch>
    </div>

    <div v-if="activeTab === 'list'" class="shops__items">
      <div v-for="store in storesFilteredByCity" :key="store.id">
        <ShopsCard :result="store" />
      </div>
    </div>

    <DefMap v-else :key="currentCityId" class="shops__map">
      <div
        v-for="store in storesFilteredByCity"
        :key="store.id"
        :lat="store.gpsN"
        :lng="store.gpsS"
        class="def-map-popup"
      >
        <h6 class="def-map-popup__title">{{ store.address }}</h6>
        <p class="def-map-popup__text">{{ store.phone }}</p>
        <p class="def-map-popup__text">{{ store.schedule }}</p>
      </div>
    </DefMap>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import DefMap from '../Def/DefMap/DefMap';
import ShopsCard from './ShopsCard';
import DefSwitch from '../Def/DefSwitch/DefSwitch';
import DefSelectWrapper from '../Def/DefSelect/DefSelectWrapper';

export default {
  name: 'Shops',
  components: {
    DefTitle,
    DefMap,
    ShopsCard,
    DefSwitch,
    DefSelectWrapper,
  },
  data() {
    return {
      activeTab: 'list',
    };
  },
  computed: {
    ...mapState({
      stores: ({ stores }) => stores.data?.stores,
      messages: ({ stores }) => stores.data?.messages,
    }),
    ...mapGetters({
      activeCityName: 'stores/getActiveCityName',
      cities: 'stores/getCities',
      storesFilteredByCity: 'stores/getStoresFilteredByCity',
      currentCityId: 'stores/getCurrentCityId',
    }),
  },
  methods: {
    ...mapMutations({
      changeCurrentCityId: 'stores/changeCurrentCityId',
    }),
  },
};
</script>

<style lang="scss" scoped>
.shops {
  margin-top: 30px;
  margin-bottom: 64px;
  @include point-lg {
    margin-bottom: 80px;
  }

  &__header {
    display: grid;
    grid-row-gap: 24px;
    margin-bottom: 24px;
    @include point-md {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-bottom: 32px;
    }
    @include point-lg {
      margin-bottom: 40px;
    }
  }

  &__items {
    display: grid;
    grid-row-gap: 8px;
  }

  &__map {
    height: 420px;
    @include point-md {
      height: 560px;
    }
  }

  :deep(.def-select-wrapper) {
    max-width: 480px;
  }
}
</style>
